module.exports = __webpack_public_path__ + "img/x7.2f43659e.jpg";